import { composeAPIFilter, getActiveFilters } from './useFilter';
import { getRndKey } from './utils';

export const reloadPageData = async (pageData, callback, pager, callBackData = {}) => {
    pageData.loading = true;
    const useTags = pageData?.useTags || false;
    const selectedTags = pageData?.selectedTags || [];
    const activeFilters = {
        isValid: true,
        ...callBackData,
        ...getActiveFilters(pageData.filters),
    };

    if (useTags) {
        activeFilters.extension = ['TAGS'];
        if (selectedTags.length > 0) {
            activeFilters.tagMatchMode = 'ALL';
            activeFilters.tagNames = selectedTags;
        }
    }

    // Add sortBy to API request
    if (pageData.sortBy && Array.isArray(pageData.sortBy) && pageData.sortBy.length > 0) {
        activeFilters.sortBy = pageData.sortBy;
    }

    //console.log('Reloading page data with sortBy:', activeFilters.sortBy);
    pageData.data = (await callback(
        composeAPIFilter(
            pageData.currentPage,
            pageData.perPage,
            pageData.search,
            ['searchTerm'],
            activeFilters,
        ),
    )) || {
        items: [],
        totalCount: 0,
    };
    pager.key = getRndKey();
    pager.current = pageData.currentPage;
    pager.end =
        pageData.data.totalCount > pageData.perPage
            ? Math.ceil(pageData.data.totalCount / pageData.perPage)
            : 1;
    pageData.loading = false;
};

export const usePages = () => {
    return {
        reloadPageData,
    };
};

export default usePages;
